import { updateNotificationHasBeenReadAllDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateNotificationHasBeenReadAllCallable = getCallable(
  updateNotificationHasBeenReadAllDefinition,
);
